import React from "react";
import { Link } from "react-router-dom";
import { blog, post, stories, users } from "../../../assets/image";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { GET_DASH_BOARD } from "../../../api/url";
import Loader from "../../../components/common/Loader";

export const Dashboard = () => {
  const { data: dashboardData, isLoading } = useAppQuery({
    queryKey: QUERY_KEYS.DASHBOARD,
    url: GET_DASH_BOARD,
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-primary">Dashboard</h1>
          <p className="mt-2 text-sm text-gray-700 capitalize">Overview of your application at a glance.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <DashboardCard
          title="Users"
          value={dashboardData?.results?.users}
          icon={users}
          link="/admin/user/user-list"
          color="bg-blue-100 text-blue-700"
        />
        <DashboardCard
          title="Posts"
          value={dashboardData?.results?.posts}
          icon={post}
          link="/admin/post/Posts"
          color="bg-green-100 text-green-700"
        />
        <DashboardCard
          title="Stories"
          value={dashboardData?.results?.stories}
          icon={stories}
          link="/admin/story/stories"
          color="bg-yellow-100 text-yellow-700"
        />
        <DashboardCard
          title="Blogs"
          value={dashboardData?.results?.blogs}
          icon={blog}
          link="/admin/blog/blogs"
          color="bg-purple-100 text-purple-700"
        />
      </div>
    </div>
  );
};

const DashboardCard = ({ title, value, icon, link, color }) => {
  return (
    <Link to={link}>
      <div className="group bg-white rounded-2xl p-6 shadow hover:shadow-lg hover:ring-2 hover:ring-blue-200  transition-all hover:scale-105 duration-300 cursor-pointer">
        <div className="flex items-center justify-between">
          <div
            className={`rounded-full p-2 bg-gradient-to-r from-blue-100 to-blue-200 w-12 h-12 flex items-center justify-center group-hover:rotate-6 group-hover:scale-110 transition`}
          >
            <img src={icon} alt={title} className="w-6 h-6" />
          </div>
          <div className="text-right">
            <h2 className="text-2xl font-bold text-primary mb-2">{value ?? 0}</h2>
            <p className="text-sm text-dark font-bold">{title}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Dashboard;
